/* eslint-disable consistent-return */
import { useEffect, useState } from 'react';

import { getPricings, Pricings } from '../services/identity/getPricings';
import { displayErrorDetails } from '../Utils/displayError';

export interface UsePricingsResult {
  pricings: Pricings[];
  loading: boolean;
}

export default function usePricings(enabled = true): UsePricingsResult {
  const [pricings, setPricings] = useState<Pricings[]>([]);
  const [loading, setLoading] = useState(enabled);

  useEffect(() => {
    if (!enabled) {
      setPricings([]);
      setLoading(false);
      return;
    }

    let active = true;
    setLoading(true);

    getPricings()
      .then((data) => {
        if (active) setPricings(data);
      })
      .catch((error) => {
        if (active) {
          setPricings([]);
          displayErrorDetails(error);
        }
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [enabled]);

  return { pricings, loading };
}
